import AdminLabs from "./labs";
import AdminLogs from './logs';
import AdminUsers from './users';
import AdminSearch from './search';
import AdminPolicy from './policy';
import AdminApiKeys from './api-keys';
import AdminSettings from './settings';
import AdminPatients from './patients';
import AdminResource from './resource';
import AdminDashboard from './dashboard';
import AdminUserRoles from './user-roles';
import AdminPharmacies from './pharmacies';
import AdminAuditTrail from './audit-trail';
import AdminDoctorNotes from './doctor-notes';
import AdminCancerTypes from './cancer-types';
import AdminAppointments from './appointments';
import AdminExcuseDuties from "./excuse-duties";
import AdminConsultations from "./consultations";
import AdminNotifications from './notifications';
import AdminAuscultations from "./auscultations";
import AdminPrescriptions from './prescriptions';
import AdminDieticianNotes from './dietician-notes';
import AdminTreatmentAdvice from "./treatment-advice";
import AdminDirectQuestions from './direct-questions';
import AdminResourceActions from './resource-actions';
import AdminDietPlanUploads from './diet-plan-uploads';
import AdminCommonComplaints from './common-complaints';
import AdminPermissionSchema from './permission-schema';
import AdminPatientDiagnosis from './patient-diagnosis';
import AdminExternalReferrals from "./external-referrals";
import AdminMedicalDiagnosisCodes from './medical-diagnosis';
import AdminPresentingQuestions from './presenting-questions';
import AdminPreviousMedications from './previous-medications';
import AdminPresentingComplaints from './presenting-complaints';
import AdminPrescriptionDeliveries from "./prescription-deliveries";

import AdminDrugs from './drugs';
import AdminDrugsRoute from './drug-route';
import AdminDrugsFormulation from './drug-formulation';
import AdminDrugsConcentration from './drug-concentration';
import AdminDrugsDoseFrequency from './drug-dose-frequency';

import AdminLabReports from './lab-report';
import AdminICD10Reports from './icd-10-report';
import AdminPatientReports from './patient-report';
import AdminPharmacyReports from './pharmacy-report';
import AdminMedicationReports from './medication-report';
import AdminConsultationReports from './consultation-report';
import AdminPatientsSeenReports from "./patients-seen-report";

import AdminGeoData from './geo-data';
import AdminLabTypes from './lab-types';
import AdminLabUploads from "./lab-uploads";
import AdminLabRequests from "./lab-requests";
import AdminLabCategories from './lab-categories';

import AdminCalls from './calls';

export default class MainJwtServices {
  axiosIns = null;
  jwtConfig = null;

  users = null;
  calls = null;
  search = null;
  policy = null;
  apiKeys = null;
  settings = null;
  resource = null;
  userRoles = null;
  resourceActions = null;
  permissionSchema = null;

  logs = null;
  auditTrail = null;

  geoData = null;
  excuseDuties = null;
  externalReferrals = null;

  labReports = null;
  icd10Reports = null;
  patientReports = null;
  pharmacyReports = null;
  medicationReports = null;
  consultationReports = null;
  adminPatientsSeenReports = null;

  drugs = null;
  drugsRoute = null;
  drugFormulation = null;
  drugConcentration = null;
  drugDoseFrequency = null;

  labTypes = null;
  labRequests = null;
  labCategories = null;
  labUploads = null;

  dieticianNotes = null;
  dietPlanUploads = null;

  labs = null;
  patients = null;
  dashboard = null;
  pharmacies = null;
  cancerTypes = null;
  doctorNotes = null;
  appointments = null;
  consultations = null;
  auscultations = null;
  notifications = null;
  directQuestions = null;
  resourceActions = null;
  treatmentAdvice = null;
  commonComplaints = null;
  previousMedications = null;
  presentingQuestions = null;
  presentingComplaints = null;
  medicalDiagnosisCodes = null;
  prescriptionDeliveries = null;

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;

    this.logs = new AdminLogs(axiosIns, jwtConfig);
    this.calls = new AdminCalls(axiosIns, jwtConfig);
    this.users = new AdminUsers(axiosIns, jwtConfig);
    this.search = new AdminSearch(axiosIns, jwtConfig);
    this.policy = new AdminPolicy(axiosIns, jwtConfig);
    this.geoData = new AdminGeoData(axiosIns, jwtConfig);
    this.apiKeys = new AdminApiKeys(axiosIns, jwtConfig);
    this.settings = new AdminSettings(axiosIns, jwtConfig);
    this.resource = new AdminResource(axiosIns, jwtConfig);
    this.dashboard = new AdminDashboard(axiosIns, jwtConfig);
    this.userRoles = new AdminUserRoles(axiosIns, jwtConfig);
    this.auditTrail = new AdminAuditTrail(axiosIns, jwtConfig);
    this.notifications = new AdminNotifications(axiosIns, jwtConfig);

    this.labReports = new AdminLabReports(axiosIns, jwtConfig);
    this.icd10Reports = new AdminICD10Reports(axiosIns, jwtConfig);
    this.patientReports = new AdminPatientReports(axiosIns, jwtConfig);
    this.pharmacyReports = new AdminPharmacyReports(axiosIns, jwtConfig);
    this.medicationReports = new AdminMedicationReports(axiosIns, jwtConfig);
    this.consultationReports = new AdminConsultationReports(axiosIns, jwtConfig);
    this.adminPatientsSeenReports = new AdminPatientsSeenReports(axiosIns, jwtConfig);

    this.drugs = new AdminDrugs(axiosIns, jwtConfig);
    this.drugsRoute = new AdminDrugsRoute(axiosIns, jwtConfig);
    this.drugFormulation = new AdminDrugsFormulation(axiosIns, jwtConfig);
    this.drugConcentration = new AdminDrugsConcentration(axiosIns, jwtConfig);
    this.drugDoseFrequency = new AdminDrugsDoseFrequency(axiosIns, jwtConfig);

    this.labTypes = new AdminLabTypes(axiosIns, jwtConfig);
    this.labRequests = new AdminLabRequests(axiosIns, jwtConfig);
    this.labCategories = new AdminLabCategories(axiosIns, jwtConfig);
    this.labUploads = new AdminLabUploads(axiosIns, jwtConfig);

    this.labs = new AdminLabs(axiosIns, jwtConfig);
    this.patients = new AdminPatients(axiosIns, jwtConfig);
    this.pharmacies = new AdminPharmacies(axiosIns, jwtConfig);
    this.doctorNotes = new AdminDoctorNotes(axiosIns, jwtConfig);
    this.cancerTypes = new AdminCancerTypes(axiosIns, jwtConfig);
    this.appointments = new AdminAppointments(axiosIns, jwtConfig);
    this.excuseDuties = new AdminExcuseDuties(axiosIns, jwtConfig);
    this.prescriptions = new AdminPrescriptions(axiosIns, jwtConfig);
    this.auscultations = new AdminAuscultations(axiosIns, jwtConfig);
    this.consultations = new AdminConsultations(axiosIns, jwtConfig);
    this.dieticianNotes = new AdminDieticianNotes(axiosIns, jwtConfig);
    this.dietPlanUploads = new AdminDietPlanUploads(axiosIns, jwtConfig);
    this.treatmentAdvice = new AdminTreatmentAdvice(axiosIns, jwtConfig);
    this.directQuestions = new AdminDirectQuestions(axiosIns, jwtConfig);
    this.resourceActions = new AdminResourceActions(axiosIns, jwtConfig);
    this.commonComplaints = new AdminCommonComplaints(axiosIns, jwtConfig);
    this.permissionSchema = new AdminPermissionSchema(axiosIns, jwtConfig);
    this.patientDiagnosis = new AdminPatientDiagnosis(axiosIns, jwtConfig);
    this.externalReferrals = new AdminExternalReferrals(axiosIns, jwtConfig);
    this.presentingQuestions = new AdminPresentingQuestions(axiosIns, jwtConfig);
    this.previousMedications = new AdminPreviousMedications(axiosIns, jwtConfig);
    this.presentingComplaints = new AdminPresentingComplaints(axiosIns, jwtConfig);
    this.medicalDiagnosisCodes = new AdminMedicalDiagnosisCodes(axiosIns, jwtConfig);
    this.prescriptionDeliveries = new AdminPrescriptionDeliveries(axiosIns, jwtConfig);
  }
}
